var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeasonTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbcbd1;}.b{fill:#f8f8f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.138)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.231,16H1.769A1.9,1.9,0,0,1,0,14V11.36A3.684,3.684,0,0,0,3.679,7.681,3.684,3.684,0,0,0,0,4V2A1.9,1.9,0,0,1,1.769,0H21.231A1.9,1.9,0,0,1,23,2V4a3.518,3.518,0,0,0-2.6,1.174A4.153,4.153,0,0,0,19.32,8,3.855,3.855,0,0,0,23,12v2A1.9,1.9,0,0,1,21.231,16Z",
    transform: "translate(0 0.138)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 16,
    transform: "translate(16 0.138)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(6 4.138)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(6 7.138)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(10 7.138)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonTicket);
export default __webpack_public_path__ + "static/media/season-ticket.269a8f5d12d3263140c635c802981a0d.svg";
export { ForwardRef as ReactComponent };